import React,{Component} from 'react';
import Select from '@react/react-spectrum/Select';
import Textfield from '@react/react-spectrum/Textfield';

class RejectAgreementReason extends Component{
    constructor(props){
        super(props);
        this.state = {
            value:'',
            otherText: '',
            isOtherSelected: false
        };
        this.handleOtherInputChange = this.handleOtherInputChange.bind(this);
        this.validateForm = this.validateForm.bind(this);
    }

    // Helper function to get localized text
    getSalesText = (path, fallback = '') => {
        if (this.props.getSalesText) {
            return this.props.getSalesText(path, fallback);
        }
        
        // Fallback to using t prop if getSalesText not available
        const { t } = this.props;
        if (t) {
            try {
                const result = t(path, { defaultValue: null });
                if (result && result !== path) {
                    return result;
                }
            } catch (error) {
                console.warn('Error getting translation for path:', path, error);
            }
        }
        
        return fallback;
    };

    // Helper function to get localized reject reasons
    getLocalizedRejectReasons = () => {
        const rejectReasonKeys = [
            'IncorrectBillingDetail',
            'IncorrectQuantity', 
            'IncorrectAdminContact',
            'IncorrectInvoiceContact',
            'MissingTaxId',
            'Other'
        ];
        
        // Try to get each individual reject reason using getSalesText
        try {
            if (this.props.getSalesText) {
                const localizedReasons = rejectReasonKeys.map(key => {
                    const path = `NEW_ORDER.labels.details.rejectReasons.${key}`;
                    const label = this.props.getSalesText(path, null);
                    
                    if (label && typeof label === 'string') {
                        return { value: key, label: label };
                    }
                    
                    // Fallback to English for this specific reason if not found
                    const fallbackLabels = {
                        'IncorrectBillingDetail': 'Incorrect Billing detail',
                        'IncorrectQuantity': 'Incorrect Quantity',
                        'IncorrectAdminContact': 'Incorrect admin contact',
                        'IncorrectInvoiceContact': 'Incorrect invoice contact',
                        'MissingTaxId': 'Missing TAX ID',
                        'Other': 'Other'
                    };
                    
                    return { value: key, label: fallbackLabels[key] || key };
                });

                return localizedReasons;
            }
        } catch (error) {
            console.warn('Error loading localized reject reasons:', error);
        }
        
        // Fallback to props.rejectReasons or default reasons
        return this.props.rejectReasons || [
            { value: 'IncorrectBillingDetail', label: 'Incorrect Billing detail' },
            { value: 'IncorrectQuantity', label: 'Incorrect Quantity' },
            { value: 'IncorrectAdminContact', label: 'Incorrect admin contact' },
            { value: 'IncorrectInvoiceContact', label: 'Incorrect invoice contact' },
            { value: 'MissingTaxId', label: 'Missing TAX ID' },
            { value: 'Other', label: 'Other' }
        ];
    };


    validateForm() {
        const { isOtherSelected, otherText } = this.state;
        
        // Form is valid if:
        // 1. "Other" is not selected (predefined option chosen), OR
        // 2. "Other" is selected AND otherText has content
        const isValid = !isOtherSelected || (isOtherSelected && otherText.trim().length > 0);
        
        // Notify parent component about validation state
        if (this.props.onValidationChange) {
            this.props.onValidationChange(isValid);
        }
        
        return isValid;
    }

    change(event){
        const isOther = event === 'Other' || event === 'other';
        
        if (isOther) {
            // When "Other" is selected, use the current otherText value or empty string
            this.props.setSelectedReason(this.state.otherText || '');
            this.setState({
                value: event, 
                isOtherSelected: true
            }, () => {
                // Validate after state update
                this.validateForm();
            });
        } else {
            // For predefined options, map selected value to its human-readable label
            const localizedReasons = this.getLocalizedRejectReasons();
            const selectedOption = localizedReasons.find(option => option.value === event);
            const readableLabel = (selectedOption && selectedOption.label) ? selectedOption.label : event;
            this.props.setSelectedReason(readableLabel);
            this.setState({
                value: event, 
                isOtherSelected: false,
                otherText: '' // Clear other text when switching away from "Other"
            }, () => {
                // Validate after state update
                this.validateForm();
            });
        }
    };

    handleOtherInputChange(value) {
        this.setState({ otherText: value }, () => {
            // Validate after state update
            this.validateForm();
        });
        // Continuously call setSelectedReason with the input value
        this.props.setSelectedReason(value);
    };

    componentDidMount() {
        const localizedReasons = this.getLocalizedRejectReasons();
        if(localizedReasons && localizedReasons.length){
            const firstOption = localizedReasons[0];
            const isOther = firstOption.value === 'Other' || firstOption.value === 'other';
            
            // Set initial selected reason to human-readable label
            this.props.setSelectedReason(isOther ? '' : (firstOption.label || firstOption.value));
            this.setState({
                value: firstOption.value,
                isOtherSelected: isOther
            }, () => {
                // Initial validation
                this.validateForm();
            });
        }
    }

    componentDidUpdate(prevProps) {
        // Check if getSalesText prop changed (indicating locale change)
        if (prevProps.getSalesText !== this.props.getSalesText) {
            // Force re-render by triggering state update 
            this.forceUpdate();
        }
    }

    render(){
        const localizedReasons = this.getLocalizedRejectReasons();
        const { disabled } = this.props;
        
        return(
            <div className="reject-agreement-reasons">
                <Select
                    onChange={this.change.bind(this)}
                    options={localizedReasons}
                    closeOnSelect={true}
                    value={this.state.value}
                    quiet
                    flexible
                    disabled={disabled}
                    data-am-id="rejectAgreementReasons"
                />
                
                {this.state.isOtherSelected && (
                    <div style={{ marginTop: '10px' }}>
                        <Textfield
                            label={this.getSalesText('NEW_ORDER.labels.details.pleaseSpecify', 'Please specify:')}
                            placeholder={this.getSalesText('NEW_ORDER.labels.details.enterReason', 'Enter your reason...')}
                            value={this.state.otherText}
                            onChange={this.handleOtherInputChange}
                            required
                            quiet
                            flexible
                            disabled={disabled}
                            data-am-id="rejectAgreementOtherInput"
                        />
                    </div>
                )}
            </div>
        )
    }
}


export default RejectAgreementReason;


